import { createSelector, createSlice } from "@reduxjs/toolkit"
import { notifiesService } from "../../services/book/notifies"
import { normalizeMessages } from "../../../packs/widgets/utils/parsers/messages"
import { bundleSyncService } from "../../services/book/bundle_sync"

const initialState = {
  meta: {},
  orders: [],
}

const bundleSyncSlice = createSlice({
  name: "bundleSync",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addMatcher(
      bundleSyncService.endpoints.getBundleSyncMeta.matchFulfilled,
      (state, action) => {
        state.meta = action.payload
      }
    )
    builder.addMatcher(bundleSyncService.endpoints.bundlesSync.matchFulfilled, (state, action) => {
      state.orders = action.payload ?? []
    })
  },
})

export const {} = bundleSyncSlice.actions

const selectBundleSyncState = (state) => state.bundleSync

export const selectBundleSyncMeta = createSelector([selectBundleSyncState], (state) => state.meta)

export const selectBundleSyncOrders = createSelector(
  [selectBundleSyncState],
  (state) => state.orders
)

export default bundleSyncSlice.reducer
